import React from 'react';

import SideNav from './SideNav';
import PlaceJumbotron from './PlaceJumbotron';
import MountainFinder from '../../components/MountainFinder';
import Flights from './Flights';
import ThemesContainer from './ThemesContainer';
import Loading from '../../components/Loading';

import './Place.css';
import Sticky from '../../components/Sticky';

export default function PlacesDesktop({ place }) {
  const { name, id, nearby_airport } = place;

  return (
    <div className="container">
      {name ? (
        <div className="row">
          <div className="col-xl-2 col-lg-2 d-xl-block d-lg-block d-none">
            <Sticky>
              <SideNav place={place} />
            </Sticky>
          </div>
          <div className="col-xl-10 col-lg-10 col-12" id="mainContentContainer">
            <PlaceJumbotron {...place} />
            {name && <ThemesContainer placeName={name} placeId={id} theme="lodges" />}
            {nearby_airport && <Flights />}
            {name && <ThemesContainer placeName={name} placeId={id} theme="sightings" />}
            {name && <ThemesContainer placeName={name} placeId={id} theme="attractions" />}
            {name && <ThemesContainer placeName={name} placeId={id} theme="sidetrips" />}
            {name && <MountainFinder id={id} placeName={name} />}
          </div>
        </div>
      ) : (
        <Loading size="small" />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Places/PlacesDesktop.jsx